export interface ToneOption {
  tone: string;
  icon: string;
  description: string;
  toneFeedback: string;
}

export const toneOptions: ToneOption[] = [
  {
    tone: "Skeptical Watchdog",
    icon: "🧐",
    description:
      "Cuts through AI hype by examining claims against evidence and questioning what companies aren't telling us.",
    toneFeedback: `
  Analyze the articles with a critical eye, while acknowledging that you're working from summaries:
  
  - Begin by acknowledging the core development or announcement
  - Identify claims that seem overstated or terminology that merits clarification
  - Note potential gaps in the information provided in the summary
  - When appropriate, connect to historical patterns in AI announcements
  - Phrase skepticism as thoughtful questions rather than definitive statements
  - Use phrases like "The summary suggests..." 
  - Invite the reader to open the article to find out more and answer the questions you raise
  - Maintain an informed, evidence-based tone that's thoughtfully skeptical but not cynical
  - Acknowledge when further information from the full article might address the questions you raise
      `,
  },
  {
    tone: "Executive Briefing",
    icon: "💼",
    description:
      "Delivers just the essential facts in bullet points for busy professionals who need information fast.",
    toneFeedback: `
    Writing guidelines:
    1. Use extremely concise language with zero fluff
    2. Include specific figures, dates, and metrics when available
    3. Use directional or visual language (e.g. up/down, rising/falling)
    4. Avoid vague qualifiers and hedging
    5. Prioritize clarity and scannability
    6. HTML output only — no markdown
    7. Important: Embed links (href, target="_blank")

    Example: 
    <section>
  <h2>[Headline]</h2>

  <p><strong>TLDR:</strong> [Concise summary]</p>

  <p><strong>Key facts:</strong></p>
  <ul>
    <li>[Fact 1]</li>
    <li>[Fact 2]</li>
    <li>[Fact 3]</li>
  </ul>

  <p><strong>Why it matters:</strong></p>
  <ul>
    <li>[Implication 1]</li>
    <li>[Implication 2]</li>
  </ul>

  <p><strong>Action points:</strong></p>
  <ul>
    <li>[Next step or thing to watch]</li>
  </ul>
</section>



    `,
  },
  {
    tone: "Technical Deep Dive",
    icon: "🔍",
    description:
      "Focuses on implementation details, architecture specifics, and technical implications of AI advancements for engineers.",
    toneFeedback: `
  Focus on the technical aspects of each development:
  
  - Begin with a brief overview of the technical significance
  - Explain the architecture, models, or systems involved when information is available
  - Compare approaches across different systems or previous versions
  - Highlight specific performance metrics, benchmarks, or technical specifications
  - Identify technical challenges and how they were addressed (or remain unsolved)
  - Discuss engineering implications and practical applications
  - Use precise technical terminology appropriate for software engineers
  - Connect developments to relevant technical concepts and principles
  - When referencing technical details from limited summaries, acknowledge limitations
  - Focus on what engineers would find most relevant about each development
      `,
  },
  {
    tone: "Make my own",
    icon: "🎨",
    description: "Customize the tone exactly how you want it",
    toneFeedback: "",
  },
];
